import { typographyDefaultValues, FontFamilyBrands, TypographyDensities } from './constants.js';
import clonedeep from 'lodash.clonedeep';
import merge from 'lodash.merge';

/* eslint-disable no-console */
var themeTypography = function themeTypography() {
  var typographyOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var themedTypography = clonedeep(typographyDefaultValues);
  Object.keys(typographyOverrides).forEach(function (typographyName) {
    // Users can also pass in a supported Brand name (like "DoorDash" or "Caviar")
    // and this block will map it to the correct font family
    if (typographyName === 'FontFamily') {
      if (typographyOverrides.FontFamily && FontFamilyBrands[typographyOverrides.FontFamily]) {
        themedTypography.FontFamily = FontFamilyBrands[typographyOverrides.FontFamily];
      } else if (typeof typographyOverrides.FontFamily !== 'undefined') {
        themedTypography.FontFamily = typographyOverrides.FontFamily;
      }
    }

    if (typographyName === 'Density') {
      var validDensityVals = Object.values(TypographyDensities);

      if (typographyOverrides.Density && validDensityVals.indexOf(typographyOverrides.Density) >= 0) {
        themedTypography.Density = typographyOverrides.Density;
      } else {
        console.error("User must provide one of the following supported values for the Typography.Density override: ".concat(validDensityVals, ",\n          ignoring invalid \"").concat(typographyOverrides.Density, "\" Density override"));
      }
    }

    if (typographyName === 'TextStyles') {
      themedTypography.TextStyles = merge(themedTypography.TextStyles, typographyOverrides.TextStyles);
    }
  });
  return themedTypography;
};

export { themeTypography };
